<template>
	<ActivityBadgeLayout class="new-item-activity-badge">
		<FontAwesomeIcon :icon="[ `fas`, `bullseye-arrow` ]" />
	</ActivityBadgeLayout>
</template>

<script>
import ActivityBadgeLayout from "./ActivityBadgeLayout";
export default {
	name: "NewItemActivityBadge",
	components: {
		ActivityBadgeLayout,
	},
};
</script>

<style lang="scss" scoped>
$badgeColor: $color2-500;
$badgeBackgroundColor: $color2-100;

.new-item-activity-badge {
	background-color: $badgeBackgroundColor;

	* {
		color: $badgeColor;
	}
}
</style>
